import React from 'react';
import { TRACKING_ID_PATH } from '@packages/common';
import { getPublicRuntimeConfig } from '@helpers/getPublicRuntimeConfig';

const TRACKING_ENABLED = getPublicRuntimeConfig('TRACKING_ENABLED');

interface ScomRenewerProps {
  isEnabled?: boolean;
}

export const ScomRenewer = ({ isEnabled = TRACKING_ENABLED }: ScomRenewerProps): JSX.Element => {
  React.useEffect(() => {
    const renew = () =>
      fetch(TRACKING_ID_PATH, {
        headers: {
          // TODO: check Connection: Keep-Alive later
          'Content-Type': 'text/javascript',
        },
      }).catch((error) => console.error('renew SCOM cookie error', error));

    if (isEnabled) {
      document.addEventListener('visibilitychange', renew);
      window.addEventListener('focus', renew);
    }

    return () => {
      document.removeEventListener('visibilitychange', renew);
      window.removeEventListener('focus', renew);
    };
  }, [isEnabled]);

  return null;
};
